import { render, staticRenderFns } from "./club-trainings.vue?vue&type=template&id=50253cce&scoped=true&"
import script from "./club-trainings.vue?vue&type=script&lang=ts&"
export * from "./club-trainings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50253cce",
  null
  
)

export default component.exports